import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TokenService } from 'src/app/services/common/token.service';
import { first } from 'rxjs';
import { ChallanService } from '../../../../services/challan-services.service';
import { ActivatedRoute } from '@angular/router';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-farmer-share',
  templateUrl: './farmer-share.component.html',
  styleUrls: ['./farmer-share.component.scss']
})
export class FarmerShareComponent implements OnInit {
  @Input() appId: any;
  @Input() progId: any;
  // public appId:any;
  // public programId:any;
  public challanPrintData:any;

  public currentDate: Date;

  constructor(
    private challanMIService: ChallanService,
    private tokenService: TokenService,
    private messageService: MessageService,
    private route: ActivatedRoute,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService, 
  ) { }

  ngOnInit(): void {
    // this.appId = this.route.snapshot.params.id;
    // this.programId = this.route.snapshot.params.pId;
    this.getDataToPrintChallan();
  }

  getDataToPrintChallan() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let mobile = farmerConfData.get('farmerPh') ? farmerConfData.get('farmerPh') : '';

    this.loader.start();
    this.challanMIService
      .getDataToPrintChallan(this.appId, this.progId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // this.activityRecordService.activityRecord(mobile, 'Farmer Share Challan', this.appId, new Date(), 'Success');

          this.challanPrintData = data;
          this.loader.close();
          this.currentDate = new Date();
        },
        error: (err) => {
          // this.activityRecordService.activityRecord(mobile, 'Farmer Share Challan', this.appId, new Date(), err);
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onPrint(divName){
    // var printContents = document.getElementById(divName).innerHTML;
    // var originalContents = document.body.innerHTML;        
    // document.body.innerHTML = printContents;
    // window.print();
    // document.body.innerHTML = originalContents;
    document.body.style.visibility="hidden";
    document.getElementById(divName).style.visibility='visible'
    document.getElementById('space_generator_for_print').style.marginTop='1000px'
    window.print();
    document.getElementById('space_generator_for_print').style.marginTop='0px'
    document.body.style.visibility="visible";
}

}
